<template>
  <div>
    <div class="background desktop">
      <div class="mandarin mandarin-1--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="mandarin mandarin-2--3">
        <img src="@/assets/img/mandarin-prediction/mandarin-3.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="mandarin mandarin-3--5">
        <img src="@/assets/img/mandarin-prediction/mandarin-5.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="background-layer background-layer--1-2"></div>
      <div class="background-layer background-layer-garland"></div>
      <div class="background-layer background-layer--1-3"></div>

      <div class="lightbulb lightbulb-yellow lightbulb-yellow-1">
        <img src="@/assets/img/mandarin-prediction/lightbulb-yellow.png" />
      </div>

      <div class="background-layer background-layer--2-1-tablet"></div>

      <div class="lightbulb lightbulb-green lightbulb-green-1">
        <img src="@/assets/img/mandarin-prediction/lightbulb-green.png" />
      </div>

      <div class="lightbulb lightbulb-blue lightbulb-blue-1">
        <img src="@/assets/img/mandarin-prediction/lightbulb-blue.png" />
      </div>

      <div class="background-layer background-layer--2-1"></div>

      <div class="mandarin mandarin-4--4">
        <img src="@/assets/img/mandarin-prediction/mandarin-4.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="mandarin mandarin-5--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="background-layer background-layer--2-2-tablet"></div>

      <div class="mandarin mandarin-6--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="background-layer background-layer--2-2"></div>

      <div class="mandarin mandarin-7--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="lightbulb lightbulb-green lightbulb-green-2">
        <img src="@/assets/img/mandarin-prediction/lightbulb-green.png" />
      </div>

      <div class="background-layer background-layer--2-3-tablet"></div>

      <div class="background-layer background-layer-garland-2"></div>

      <div class="background-layer background-layer--3-1"></div>

      <div class="mandarin mandarin-8--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="mandarin mandarin-9--2">
        <img src="@/assets/img/mandarin-prediction/mandarin-2.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="mandarin mandarin-10--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="background-layer background-layer--3-2"></div>

      <div class="lightbulb lightbulb-blue lightbulb-blue-2">
        <img src="@/assets/img/mandarin-prediction/lightbulb-blue.png" />
      </div>

      <div class="background-layer background-layer--3-3"></div>

      <div class="lightbulb lightbulb-yellow lightbulb-yellow-2">
        <img src="@/assets/img/mandarin-prediction/lightbulb-yellow.png" />
      </div>

      <div class="background-layer background-layer--4"></div>

      <div class="mandarin mandarin-11--3">
        <img src="@/assets/img/mandarin-prediction/mandarin-3.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="background-layer background-layer--5"></div>

      <div class="background-layer background-layer--6"></div>

      <div class="background-layer background-layer--sparkles"></div>
    </div>

    <div class="background mobile">
      <div class="mandarin mandarin-3--5">
        <img src="@/assets/img/mandarin-prediction/mandarin-5.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="background-layer background-layer--2"></div>

      <div class="lightbulb lightbulb-green lightbulb-green-1">
        <img src="@/assets/img/mandarin-prediction/lightbulb-green.png" />
      </div>

      <div class="background-layer background-layer--3"></div>

      <div class="mandarin mandarin-2--3">
        <img src="@/assets/img/mandarin-prediction/mandarin-3.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="background-layer background-layer--4"></div>

      <div class="lightbulb lightbulb-yellow lightbulb-yellow-1">
        <img src="@/assets/img/mandarin-prediction/lightbulb-yellow.png" />
      </div>

      <div class="background-layer background-layer-garland"></div>

      <div class="lightbulb lightbulb-blue lightbulb-blue-1">
        <img src="@/assets/img/mandarin-prediction/lightbulb-blue.png" />
      </div>

      <div class="background-layer background-layer--5"></div>

      <div class="mandarin mandarin-1--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="mandarin mandarin-6--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="mandarin mandarin-8--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="background-layer background-layer--6"></div>

      <div class="lightbulb lightbulb-green lightbulb-green-2">
        <img src="@/assets/img/mandarin-prediction/lightbulb-green.png" />
      </div>

      <div class="background-layer background-layer--7"></div>
      <div class="background-layer background-layer-garland-2"></div>
      <div class="background-layer background-layer--8"></div>

      <div class="lightbulb lightbulb-yellow lightbulb-yellow-2">
        <img src="@/assets/img/mandarin-prediction/lightbulb-yellow.png" />
      </div>

      <div class="background-layer background-layer--9"></div>

      <div class="mandarin mandarin-9--2">
        <img src="@/assets/img/mandarin-prediction/mandarin-2.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="mandarin mandarin-11--3">
        <img src="@/assets/img/mandarin-prediction/mandarin-3.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="lightbulb lightbulb-blue lightbulb-blue-2">
        <img src="@/assets/img/mandarin-prediction/lightbulb-blue.png" />
      </div>

      <div class="background-layer background-layer--10"></div>

      <div class="mandarin mandarin-10--1">
        <img src="@/assets/img/mandarin-prediction/mandarin-1.png" />
        <div @click="toPrediction" class="mandarin-clickable"></div>
      </div>

      <div class="background-layer background-layer--11"></div>
      <div class="background-layer background-layer--sparkles"></div>
    </div>

    <modal ref="modal" />
  </div>
</template>

<script>
import Modal from '@/components/mandarin-prediction/Modal.vue'
export default {
  name: 'MandarinPrediction',
  components: { Modal },
  data() {
    return {}
  },
  async mounted() {
    await setTimeout(this.$refs.modal.open, 5000)
  },
  methods: {
    toPrediction() {
      this.$router.push({ name: 'Prediction' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mandarin-prediction/_animations.scss';
@import '@/assets/scss/mandarin-prediction/_base.scss';

.background {
  width: 100vw;
  height: 100vh;
  object-fit: cover;
  background-image: url('~@/assets/img/mandarin-prediction/layer-1.png'),
    url('~@/assets/img/mandarin-prediction/background.png');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  overflow: hidden;
  position: relative;
  z-index: 0;

  &.mobile {
    display: none;
  }

  &-layer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

    &-garland {
      width: 165.5vw;
      height: 82.5vw;
      left: -21.25vw;
      top: -6vw;
      transform: rotate(6.1deg);
    }

    &-garland-2 {
      width: 164.1vw;
      height: 81.8vw;
      left: -12.1vw;
      top: -45.6vw;
      transform: rotate(11.77deg);
    }

    &--1-2 {
      background-image: url('~@/assets/img/mandarin-prediction/layer-1-2.png');
    }

    &--1-3 {
      background-image: url('~@/assets/img/mandarin-prediction/layer-1-3.png');
    }

    &--2-1 {
      background-image: url('~@/assets/img/mandarin-prediction/layer-2-1.png');
    }

    &--2-2 {
      background-image: url('~@/assets/img/mandarin-prediction/layer-2-2.png');
    }

    &--3-1 {
      background-image: url('~@/assets/img/mandarin-prediction/layer-3-1.png');
    }

    &--3-2 {
      background-image: url('~@/assets/img/mandarin-prediction/layer-3-2.png');
    }

    &--3-3 {
      background-image: url('~@/assets/img/mandarin-prediction/layer-3-3.png');
    }

    &--4 {
      background-image: url('~@/assets/img/mandarin-prediction/layer-4.png');
    }

    &--5,
    &--6 {
      display: none;
    }

    &--sparkles {
      background-image: url('~@/assets/img/mandarin-prediction/sparkles.png');
    }
  }
}

.lightbulb {
  position: absolute;
  background-size: contain;

  img {
    width: 100%;
    height: auto;
  }
}

.lightbulb-yellow {
  &-1 {
    width: 18.4vw;
    left: 17.35vw;
    bottom: -1.8vh;
    transform: rotate(58.59deg);
  }

  &-2 {
    width: 17.3vw;
    left: 53.8vw;
    top: 0;
    transform: rotate(31.96deg);
  }
}

.lightbulb-green {
  &-1 {
    width: 19vw;
    right: -4.2vw;
    bottom: 14.2vh;
    transform: rotate(-64.17deg);
  }

  &-2 {
    width: 19vw;
    left: 18vw;
    top: 6.9vh;
    transform: rotate(-5.21deg);
  }
}

.lightbulb-blue {
  width: 17vw;

  &-1 {
    right: 19.7vw;
    bottom: 32.5vh;
    transform: rotate(-64.17deg);
  }

  &-2 {
    right: 5.6vw;
    top: -6.3vh;
    transform: rotate(-155.99deg);
  }
}

.mandarin {
  position: absolute;

  &.mobile {
    display: none;
  }

  &:hover {
    img {
      visibility: hidden;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      background: url('~@/assets/img/mandarin-prediction/mandarin-open.png');
      background-size: contain;
      transform: rotate(-142.17deg);
      background-repeat: no-repeat;
    }
  }

  img {
    width: 100%;
  }
  .mandarin-clickable {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 100;
    cursor: pointer;
  }
}

.mandarin-1--1 {
  left: 4.8vw;
  bottom: 7.6vh;
  width: 13.2vw;
}

.mandarin-2--3 {
  position: absolute;
  left: 33.7vw;
  bottom: -5.8vh;
  width: 21.2vw;
}

.mandarin-3--5 {
  position: absolute;
  right: 10.7vw;
  bottom: 2.5vh;
  width: 17.2vw;
}

.mandarin-4--4 {
  position: absolute;
  left: -8.2vw;
  top: 20.5vh;
  width: 20vw;
}

.mandarin-5--1 {
  position: absolute;
  left: 22.4vw;
  top: 40.4vh;
  width: 13.7vw;
}

.mandarin-6--1 {
  position: absolute;
  left: 43.75vw;
  top: 32.6vh;
  width: 18vw;
}

.mandarin-7--1 {
  position: absolute;
  right: 5.7vw;
  top: 31.2vh;
  width: 13.2vw;
}

.mandarin-8--1 {
  position: absolute;
  left: 10.4vw;
  top: -9.6vh;
  width: 13.2vw;
}

.mandarin-9--2 {
  position: absolute;
  left: 32.3vw;
  top: -9.5vh;
  width: 20.8vw;

  &:hover::before {
    left: 12%;
    right: 12%;
  }
}

.mandarin-10--1 {
  position: absolute;
  right: -3.8vw;
  top: 3vh;
  width: 13.2vw;
  img {
    transform: rotate(-144deg);
  }
}

.mandarin-11--3 {
  position: absolute;
  right: 21.6vw;
  top: -6.9vh;
  width: 19.5vw;
  img {
    transform: rotate(-12.41deg);
  }
}

@media (min-width: 769px) and (max-width: 1024px) and (orientation: portrait) {
  .background {
    background-image: url('~@/assets/img/mandarin-prediction/layer-1-tablet.png'),
      url('~@/assets/img/mandarin-prediction/background.png');

    &-layer {
      &--1-2,
      &--1-3,
      &--2-1,
      &--2-2,
      &--3-2,
      &--3-3,
      &--5,
      &--6 {
        display: none;
      }

      &--2-1-tablet {
        background-image: url('~@/assets/img/mandarin-prediction/layer-2-1-tablet.png');
      }

      &--2-2-tablet {
        background-image: url('~@/assets/img/mandarin-prediction/layer-2-2-tablet.png');
      }

      &--2-3-tablet {
        background-image: url('~@/assets/img/mandarin-prediction/layer-2-3-tablet.png');
      }

      &--3-1 {
        background-image: url('~@/assets/img/mandarin-prediction/layer-3-1-tablet.png');
      }

      &--4 {
        background-image: url('~@/assets/img/mandarin-prediction/layer-4-tablet.png');
      }

      &--sparkles {
        background-image: url('~@/assets/img/mandarin-prediction/sparkles-tablet.png');
      }

      &-garland {
        width: 320vw;
        height: 207vw;
        top: -18vw;
        left: -88vw;
        background-size: contain;
      }

      &-garland-2 {
        width: 317vw;
        height: 206vw;
        top: -102vw;
        left: -68vw;
        background-size: contain;
      }
    }

    .lightbulb-yellow-1 {
      width: 34.5vw;
      bottom: 9vh;
      left: -14.5vw;
    }

    .lightbulb-blue-1 {
      width: 33vw;
      right: -8.5vw;
      bottom: 36vh;
      transform: rotate(-128.56deg);
    }

    .lightbulb-green-1,
    .lightbulb-blue-2 {
      display: none;
    }

    .lightbulb-green-2 {
      width: 40vw;
      transform: rotate(-5.21deg);
      top: 16vh;
      left: -13.8vw;
    }

    .lightbulb-yellow-2 {
      width: 34.5vw;
      top: 11vh;
      right: 14.4vw;
    }
  }

  .mandarin-1--1,
  .mandarin-4--4,
  .mandarin-7--1,
  .mandarin-8--1,
  .mandarin-10--1,
  .mandarin-11--3 {
    display: none;
  }

  .mandarin-2--3 {
    width: 40.8vw;
    bottom: 3.3vh;
    left: 17vw;
  }

  .mandarin-3--5 {
    width: 33.1vw;
    bottom: 10vh;
    right: -24.6vw;
  }

  .mandarin-5--1 {
    width: 26.5vw;
    left: -5.6vw;
    bottom: 39.3vh;
  }

  .mandarin-6--1 {
    width: 35vw;
    left: 36vw;
    bottom: 40vh;
  }

  .mandarin-9--2 {
    width: 39.5vw;
    top: 1vh;
    left: 14.4vw;
  }
}

@media (max-width: 768px) and (orientation: portrait) {
  .desktop {
    display: none;
  }

  .background {
    &.mobile {
      display: block;
      background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-1.png'),
        url('~@/assets/img/mandarin-prediction/mobile/background.png');
    }

    &-layer {
      &--2 {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-2.png');
      }

      &--3 {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-3.png');
      }

      &--4 {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-4.png');
      }

      &--5 {
        display: block;
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-5.png');
      }

      &--6 {
        display: block;
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-6.png');
      }

      &--7 {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-7.png');
      }

      &--8 {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-8.png');
      }

      &--9 {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-9.png');
      }

      &--10 {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-10.png');
      }

      &--11 {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/layer-11.png');
      }

      &-garland {
        width: 354.5vw;
        height: 200vw;
        left: -116.9vw;
        top: 27vw;
        transform: rotate(-4.85deg);
        background-size: 100% auto;
      }

      &-garland-2 {
        width: 307vw;
        height: 200vw;
        left: -81.5vw;
        top: -55vw;
        transform: rotate(10.64deg);
        background-size: 100% auto;
      }

      &--sparkles {
        background-image: url('~@/assets/img/mandarin-prediction/mobile/sparkles.png');
      }
    }
  }
  .mandarin-1--1 {
    width: 25.9vw;
    bottom: 36.85vh;
    left: -9.5vw;
    display: block;
  }

  .mandarin-2--3 {
    width: 40vw;
    bottom: 10.5vh;
    left: 3vw;
    display: block;
  }

  .mandarin-3--5 {
    width: 32.3vw;
    bottom: 14.3vh;
    right: 2.36vw;
  }

  .mandarin-8--1 {
    width: 34.4vw;
    left: 31.5vw;
    top: 46.6vh;
  }

  .mandarin-6--1 {
    width: 25vw;
    right: -16.7vw;
    top: 45.9vh;
    left: auto;
    z-index: 20;
  }

  .mandarin-9--2 {
    width: 38.9vw;
    top: 27.2vh;
    left: 8.2vw;
    display: block;
  }

  .mandarin-10--1 {
    width: 25vw;
    top: 9.5vh;
    left: 27.5vw;
    display: block;
  }

  .mandarin-11--3 {
    width: 41vw;
    top: 20.3vh;
    right: 1.7vw;
  }

  .mobile {
    .lightbulb-green-1 {
      width: 35.5vw;
      bottom: 5vh;
      left: 34.6vw;
      transform: rotate(-34deg);
    }

    .lightbulb-yellow-1 {
      width: 35.1vw;
      bottom: 22.1vh;
      right: 32.5vw;
      left: auto;
      transform: rotate(146deg);
    }

    .lightbulb-yellow-2 {
      width: 35.1vw;
      top: 28vh;
      right: 15.8vw;
      left: auto;
      transform: rotate(31.96deg);
    }

    .lightbulb-blue-1 {
      width: 35.3vw;
      bottom: 32.2vh;
      right: -3vw;
      transform: rotate(-140deg);
    }

    .lightbulb-blue-2 {
      width: 35.3vw;
      top: 21vh;
      left: -8.4vw;
      transform: rotate(-24.75deg);
    }

    .lightbulb-green-2 {
      width: 39.4vw;
      bottom: 47.6vh;
      top: auto;
      left: -11vw;
      transform: rotate(-11.7deg);
    }
  }
}
</style>
